import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const params = JSON.parse(this.data.get("params") || '{}');

    $(this.element).flatpickr({
        dateFormat: 'Y-m-d',
        ...params,
    });
  }

  disconnect() {
    $(this.element).flatpickr('destroy');
  }
}
